// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1666":"a5bc15eec45b7dfe","5335":"c259c55259cd651f","6944":"c8a8bd69a44f7740"}[chunkId] + ".css";
};